/**
 * Cart delivery interval (1 / 2 / 3 months): scales subscription line quantities,
 * optional selling plan swap from theme IDs, stores cart attribute delivery_interval_months.
 */
(function () {
  function parseJson(sel, root) {
    var el = root.querySelector(sel);
    if (!el || !el.textContent) return null;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return null;
    }
  }

  function fetchCfg() {
    if (typeof fetchConfigDefaults === "function") {
      return fetchConfigDefaults("application/javascript");
    }
    return {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        Accept: "application/javascript",
      },
    };
  }

  function monthsFromBillingPolicy(alloc) {
    if (!alloc) return null;
    var ic = parseInt(alloc.billingIntervalCount, 10);
    if (isNaN(ic) || ic < 1 || ic > 12) return null;
    var iv = (alloc.billingInterval || "").toString().toLowerCase();
    if (
      iv &&
      iv !== "month" &&
      iv !== "months" &&
      iv !== "monthly"
    ) {
      return null;
    }
    return ic;
  }

  function findAllocationForPlanId(line, planId) {
    if (!line.allocations || planId == null) return null;
    var ps = String(planId);
    for (var i = 0; i < line.allocations.length; i++) {
      if (String(line.allocations[i].planId) === ps) return line.allocations[i];
    }
    return null;
  }

  /** Pick plan on this line for 1 / 2 / 3 month billing (per-variant Skio plans). */
  function resolvePlanIdByBilling(line, wantMonths) {
    if (!line.allocations) return null;
    for (var i = 0; i < line.allocations.length; i++) {
      var m = monthsFromBillingPolicy(line.allocations[i]);
      if (m === wantMonths) return Number(line.allocations[i].planId);
    }
    return null;
  }

  /** Match Skio / Shopify names like "Every 1 Month", "Every 2 Months". */
  function inferMonthsFromPlanName(name) {
    if (!name) return null;
    var s = (name + "").trim();
    if (/every\s*3\s*months?/i.test(s) || /\b3\s*[\s-]*months?\b/i.test(s))
      return 3;
    if (/every\s*2\s*months?/i.test(s) || /\b2\s*[\s-]*months?\b/i.test(s))
      return 2;
    if (/every\s*1\s*months?/i.test(s) || /\b1\s*[\s-]*months?\b/i.test(s))
      return 1;
    return null;
  }

  function resolvePlanIdByName(line, wantMonths) {
    if (!line.allocations) return null;
    for (var i = 0; i < line.allocations.length; i++) {
      if (inferMonthsFromPlanName(line.allocations[i].name) === wantMonths) {
        return Number(line.allocations[i].planId);
      }
    }
    return null;
  }

  function resolvePlanId(line, intervalMonths, planConfig) {
    var want = parseInt(intervalMonths, 10);
    if (want !== 1 && want !== 2 && want !== 3) want = 1;
    if (!line.allocations || !line.allocations.length) {
      return Number(line.currentSellingPlanId);
    }

    var byBill = resolvePlanIdByBilling(line, want);
    if (byBill !== null && !isNaN(byBill)) return byBill;

    var byName = resolvePlanIdByName(line, want);
    if (byName !== null && !isNaN(byName)) return byName;

    var raw =
      want === 1
        ? planConfig.planId1
        : want === 2
          ? planConfig.planId2
          : planConfig.planId3;
    if (raw == null || raw === "") return Number(line.currentSellingPlanId);
    var ws = String(raw).trim();
    if (!ws) return Number(line.currentSellingPlanId);
    for (var i = 0; i < line.allocations.length; i++) {
      if (String(line.allocations[i].planId) === ws) {
        return Number(line.allocations[i].planId);
      }
    }
    return Number(line.currentSellingPlanId);
  }

  function newQuantity(lineQty, prevMonths, nextMonths) {
    var p = parseInt(prevMonths, 10) || 1;
    var n = parseInt(nextMonths, 10) || 1;
    if (p < 1) p = 1;
    if (n < 1) n = 1;
    var base = Math.max(1, Math.floor(Number(lineQty) / p));
    return base * n;
  }

  function modalSectionsBody() {
    if (
      !window.theme ||
      !window.theme.settings ||
      window.theme.settings.cartType !== "modal"
    ) {
      return {};
    }
    return {
      sections: "cart-items,cart-footer,cart-item-count,cart-live-region",
      sections_url: window.location.pathname,
    };
  }

  function refreshCartFromSections() {
    var path =
      typeof window.location.pathname === "string"
        ? window.location.pathname
        : "/";
    var sep = path.indexOf("?") >= 0 ? "&" : "?";
    var url =
      path +
      sep +
      "sections=cart-items,cart-footer,cart-item-count,cart-live-region";
    return fetch(url, { credentials: "same-origin" })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (out) {
        if (!out.ok || !out.data || typeof out.data !== "object") return;
        if (out.data.status) return;
        document.dispatchEvent(
          new CustomEvent("shapes:cart:update", {
            bubbles: true,
            detail: {
              response: {
                sections: out.data,
              },
            },
          })
        );
      });
  }

  /** Shopify rotates line item keys after each /cart/change; always read fresh keys from /cart.js between updates. */
  function cartJsonUrl() {
    var base =
      window.theme && window.theme.routes && window.theme.routes.cart_url;
    if (!base || typeof base !== "string") return "/cart.js";
    return base.slice(-3) === ".js" ? base : base.replace(/\/?$/, "") + ".js";
  }

  function parseLiveSubscriptionSnapshots(cart) {
    var out = [];
    if (!cart || !cart.items || !cart.items.length) return out;
    for (var j = 0; j < cart.items.length; j++) {
      var item = cart.items[j];
      if (!item.selling_plan_allocation) continue;
      var sp = item.selling_plan_allocation.selling_plan;
      var sid = NaN;
      if (sp && sp.id != null) sid = Number(sp.id);
      if (isNaN(sid) && item.selling_plan_allocation.selling_plan_id != null) {
        sid = Number(item.selling_plan_allocation.selling_plan_id);
      }
      out.push({
        key: item.key,
        quantity: item.quantity,
        variantId: item.variant_id,
        currentSellingPlanId: isNaN(sid) ? null : sid,
      });
    }
    return out;
  }

  function fetchLiveSubscriptionSnapshots() {
    return fetch(cartJsonUrl(), { credentials: "same-origin" }).then(function (
      res
    ) {
      return res.json().then(function (cart) {
        return parseLiveSubscriptionSnapshots(cart);
      });
    });
  }

  function mergeStaticLineWithLive(staticLine, live) {
    if (!live || live.key == null || String(live.key).trim() === "") {
      return staticLine;
    }
    return Object.assign({}, staticLine, {
      key: live.key,
      quantity: live.quantity,
      currentSellingPlanId:
        live.currentSellingPlanId != null && !isNaN(live.currentSellingPlanId)
          ? live.currentSellingPlanId
          : staticLine.currentSellingPlanId,
    });
  }

  function changeLine(line, quantity, sellingPlanId) {
    var sid = Number(sellingPlanId);
    if (isNaN(sid) || sid <= 0) {
      sid = Number(line.currentSellingPlanId);
    }
    if (line.key == null || String(line.key).trim() === "") {
      return Promise.resolve({
        ok: false,
        data: { status: "bad_request", description: "Missing line key" },
      });
    }
    var body = Object.assign(
      {
        id: line.key,
        quantity: quantity,
        selling_plan: sid,
      },
      modalSectionsBody()
    );
    var cfg = fetchCfg();
    cfg.headers["Content-Type"] = "application/json";
    cfg.body = JSON.stringify(body);
    return fetch(window.theme.routes.cart_change_url, cfg).then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      });
    });
  }

  function updateCartAttribute(months) {
    var cfg = fetchCfg();
    cfg.headers["Content-Type"] = "application/json";
    cfg.body = JSON.stringify({
      attributes: {
        delivery_interval_months: String(months),
      },
    });
    return fetch(window.theme.routes.cart_update_url, cfg).then(function (res) {
      return res.json();
    });
  }

  function syncIntervalChoicesUi(root, selectedMonths) {
    var s = String(selectedMonths);
    root.querySelectorAll("[data-interval-choice]").forEach(function (btn) {
      var v = btn.getAttribute("data-interval-value") || "";
      var isOn = v === s;
      btn.setAttribute("aria-checked", isOn ? "true" : "false");
      btn.classList.toggle("cart-delivery-interval__choice--active", isOn);
    });
  }

  function setBusy(root, on) {
    var b = root.querySelector("[data-interval-busy]");
    root.querySelectorAll("[data-interval-choice]").forEach(function (btn) {
      btn.disabled = !!on;
    });
    if (!b) return;
    if (on) {
      b.classList.remove("hidden");
      b.hidden = false;
    } else {
      b.classList.add("hidden");
      b.hidden = true;
    }
  }

  function normalizePlanId(raw) {
    return raw != null && String(raw).trim() !== ""
      ? String(raw).trim()
      : "";
  }

  /**
   * Infer 1/2/3 month mode from the first subscription line’s current plan:
   * billing policy on allocations (works across Gummies / Drops / Shake),
   * then theme plan ID overrides, then null.
   */
  function inferDominantMonthsFromLines(lines, planConfig) {
    if (!lines || !lines.length) return null;
    var first = lines[0];
    var curAlloc = findAllocationForPlanId(first, first.currentSellingPlanId);
    var m = monthsFromBillingPolicy(curAlloc);
    if (m !== null && m >= 1 && m <= 3) return m;
    if (curAlloc) {
      var fromName = inferMonthsFromPlanName(curAlloc.name);
      if (fromName !== null) return fromName;
    }

    var pid = normalizePlanId(first.currentSellingPlanId);
    var p1 = normalizePlanId(planConfig.planId1);
    var p2 = normalizePlanId(planConfig.planId2);
    var p3 = normalizePlanId(planConfig.planId3);
    if (!p1 && !p2 && !p3) return null;
    if (p1 && pid === p1) return 1;
    if (p2 && pid === p2) return 2;
    if (p3 && pid === p3) return 3;
    return null;
  }

  /**
   * If cart attribute/UI says monthly but Shopify lines sit on multi-month plans,
   * sync quantities + selling plans down to monthly. If attribute is stuck at 2/3
   * but plans are monthly, reset the cart attribute without touching lines.
   */
  async function bootstrapMonthlyDefault(root) {
    if (root._deliveryIntervalMonthlyBootstrapRan) return;
    if (root._deliveryIntervalMonthlyBootstrapBusy) return;
    root._deliveryIntervalMonthlyBootstrapBusy = true;
    try {
      var lines = parseJson("[data-cart-delivery-lines]", root);
      var planConfig = parseJson("[data-cart-delivery-plan-config]", root) || {};
      if (!lines || !lines.length) {
        root._deliveryIntervalMonthlyBootstrapRan = true;
        return;
      }
      var declared = parseInt(
        root.getAttribute("data-current-interval") || "1",
        10
      );
      if (declared !== 1 && declared !== 2 && declared !== 3) declared = 1;
      var inferred = inferDominantMonthsFromLines(lines, planConfig);

      /** Plans read as monthly but cart attribute/UI still thinks 2- or 3-month */
      if (inferred !== null && inferred === 1 && declared !== 1) {
        root._deliveryIntervalMonthlyBootstrapRan = true;
        await applyInterval(root, 1);
        return;
      }
      /** Attribute says monthly but Shopify lines sit on multi-month plans */
      if (inferred !== null && inferred !== 1 && declared === 1) {
        root._deliveryIntervalMonthlyBootstrapRan = true;
        root.setAttribute("data-current-interval", String(inferred));
        await applyInterval(root, 1);
        return;
      }
      root._deliveryIntervalMonthlyBootstrapRan = true;
    } finally {
      root._deliveryIntervalMonthlyBootstrapBusy = false;
    }
  }

  async function applyInterval(root, nextMonths) {
    var lines = parseJson("[data-cart-delivery-lines]", root);
    var planConfig = parseJson("[data-cart-delivery-plan-config]", root) || {};
    var prevMonths = parseInt(
      root.getAttribute("data-current-interval") || "1",
      10
    );
    if (prevMonths !== 1 && prevMonths !== 2 && prevMonths !== 3) {
      prevMonths = 1;
    }
    nextMonths = parseInt(
      nextMonths === null || nextMonths === undefined
        ? "1"
        : String(nextMonths),
      10
    );
    if (nextMonths !== 1 && nextMonths !== 2 && nextMonths !== 3) return;
    if (prevMonths === nextMonths) return;
    if (!lines || !lines.length) return;

    setBusy(root, true);
    try {
      for (var i = 0; i < lines.length; i++) {
        var liveSubs = await fetchLiveSubscriptionSnapshots();
        if (!liveSubs || liveSubs.length !== lines.length) {
          syncIntervalChoicesUi(root, prevMonths);
          if (window.theme.strings && window.theme.strings.cartError) {
            window.alert(window.theme.strings.cartError);
          }
          await refreshCartFromSections();
          return;
        }
        var line = mergeStaticLineWithLive(lines[i], liveSubs[i]);
        var qty = newQuantity(line.quantity, prevMonths, nextMonths);
        var planId = resolvePlanId(line, nextMonths, planConfig);
        var out = await changeLine(line, qty, planId);
        if (!out.ok || (out.data && out.data.status)) {
          syncIntervalChoicesUi(root, prevMonths);
          var msg =
            (out.data &&
              (out.data.description || out.data.message || out.data.errors)) ||
            (window.theme.strings && window.theme.strings.cartError);
          if (msg) window.alert(msg);
          return;
        }
      }
      await updateCartAttribute(nextMonths);
      await refreshCartFromSections();
    } catch (e) {
      console.error(e);
      syncIntervalChoicesUi(root, prevMonths);
      if (window.theme.strings && window.theme.strings.cartError) {
        window.alert(window.theme.strings.cartError);
      }
    } finally {
      setBusy(root, false);
    }
  }

  /**
   * Cart footer is morphed via Alpine.morph; the outer [data-cart-delivery-interval]
   * node can be reused while inner nodes are replaced. Per-root click listeners would
   * stay bound to removed DOM or never re-attach when _deliveryIntervalInit remains true.
   * Delegate from document so interval buttons stay clickable after every morph.
   */
  var documentClickDelegationBound = false;
  function bindIntervalChoiceDelegation() {
    if (documentClickDelegationBound) return;
    documentClickDelegationBound = true;
    document.addEventListener(
      "click",
      function (e) {
        var btn = e.target.closest("[data-interval-choice]");
        if (!btn || btn.disabled) return;
        var root = btn.closest("[data-cart-delivery-interval]");
        if (!root) return;
        var raw = btn.getAttribute("data-interval-value");
        if (raw == null || raw === "") return;
        applyInterval(root, raw);
      },
      true
    );
  }

  function resetBootstrapFlagsOnIntervalRoots() {
    document.querySelectorAll("[data-cart-delivery-interval]").forEach(function (root) {
      root._deliveryIntervalMonthlyBootstrapRan = false;
    });
  }

  function scan() {
    bindIntervalChoiceDelegation();
    document.querySelectorAll("[data-cart-delivery-interval]").forEach(function (root) {
      if (!root.querySelector("[data-interval-choice]")) return;
      bootstrapMonthlyDefault(root).catch(function (err) {
        console.error(err);
      });
    });
  }

  function scheduleScan() {
    resetBootstrapFlagsOnIntervalRoots();
    requestAnimationFrame(scan);
  }

  document.addEventListener("DOMContentLoaded", function () {
    bindIntervalChoiceDelegation();
    scan();
  });
  document.addEventListener("theme:cart:update", scheduleScan);
  document.addEventListener("theme:cart:change", scheduleScan);
  document.addEventListener("theme:product:add", scheduleScan);
  document.addEventListener("shopify:section:load", scheduleScan);

  document.addEventListener(
    "cart-is-open",
    function () {
      requestAnimationFrame(function () {
        document
          .querySelectorAll("[data-cart-delivery-interval]")
          .forEach(function (root) {
            if (!root.querySelector("[data-interval-choice]")) return;
            root._deliveryIntervalMonthlyBootstrapRan = false;
            bootstrapMonthlyDefault(root).catch(function (err) {
              console.error(err);
            });
          });
      });
    },
    true
  );

})();
